import React, { useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import ModalDialogContext from "../../Context/ModalDialog/ModalDialogContext";
import LoadingIndicator from "../LoadingIndicator";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 2,
  },
  closeButton: {
    position: "absolute",
    color: theme.palette.grey[500],
  },
  dialogPaper: {
    minHeight: 200,
    minWidth: 400,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, status } = props;

  if (status === "failure") {
    return (
      <MuiDialogTitle
        disableTypography
        className={classes.root}
        style={{
          padding: "5px 15px",
          backgroundColor: "#d84a4a",
          color: "white",
        }}
      >
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  } else {
    return (
      <MuiDialogTitle
        disableTypography
        className={classes.root}
        style={{ padding: "5px 15px", backgroundColor: "#7ed321b0" }}
      >
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  }
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 25,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
  },
}))(MuiDialogActions);

const ModalDialogWithContext = withStyles(styles)((props) => {
  const { classes } = props;
  const { t } = useTranslation();
  const {
    visible,
    title,
    message,
    onPressOk,
    onPressYes,
    onPressNo,
    onPressCancel,
    hideModalDialog,
    loading,
    status,
    yesLabel,
    noLabel,
  } = useContext(ModalDialogContext);

  return (
    <React.Fragment>
      <Dialog
        onClose={hideModalDialog}
        aria-labelledby="customized-dialog-title"
        open={visible}
        classes={loading ? {} : { paper: classes.dialogPaper }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        {loading ? (
          <div
            style={{
              height: 100,
              width: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingIndicator />
          </div>
        ) : (
          <React.Fragment>
            <DialogTitle onClose={onPressCancel} status={status}>
              {title}
            </DialogTitle>
            <DialogContent>
              <Typography
                style={{
                  whiteSpace: "pre-line",
                }}
                gutterBottom
              >
                {message}
              </Typography>
            </DialogContent>
            <DialogActions>
              <React.Fragment>
                {onPressYes ? (
                  <Button onClick={onPressYes} color="primary">
                    {yesLabel}
                  </Button>
                ) : null}
                {onPressNo ? (
                  <Button onClick={onPressNo} color="primary">
                    {noLabel}
                  </Button>
                ) : null}
                {onPressOk ? (
                  <Button onClick={onPressOk} color="primary">
                    {t("labels.common.ok")}
                  </Button>
                ) : null}
                {onPressCancel ? (
                  <Button onClick={onPressCancel} color="primary">
                    {t("labels.common.cancel")}
                  </Button>
                ) : null}
              </React.Fragment>
            </DialogActions>
          </React.Fragment>
        )}
      </Dialog>
    </React.Fragment>
  );
});

ModalDialogWithContext.propTypes = {
  //
};

ModalDialogWithContext.defaultProps = {
  //
};

export default ModalDialogWithContext;
